export async function addProductsToWebsiteCart(productCode: string, quantity: number, special_data?: object | null) {
  console.log('Adding product to cart:', productCode, quantity, special_data);

  let session = null;

  // Find OCSESSID cookie
  const cookies = document.cookie.split(';');
  for (let cookie of cookies) {
    const [name, value] = cookie.trim().split('=');
    if (name === 'OCSESSID') {
      session = value;
      break;
    }
  }

  try {
    const response = await fetch('/findly/cart', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        product_id: productCode,
        product_code: productCode,
        quantity: quantity,
        special_data: special_data,
        session: session,
      }),
    });

    if (!response.ok) throw new Error(`Failed to add product to cart: ${response.statusText}`);

    console.log('Product added to cart:', response);

    try {
      document.querySelector('#cart-refresh')?.dispatchEvent(new Event('click'));
    } catch (error) {
      console.error('Error refreshing cart:', error);
    }

  } catch (error) {
    console.error('Error adding product to cart:', error);
  }
}